import * as yup from 'yup'

export const schemaInvoice = yup.object().shape({
  contractOverdue: yup
    .number()
    .typeError('Preencha este campo')
    .min(0)
    .max(120)
    .required(),
  contractCancelOverdue: yup
    .number()
    .typeError('Preencha este campo')
    .min(0)
    .max(120)
    .required(),
  contractCancelPending: yup
    .number()
    .typeError('Preencha este campo')
    .min(0)
    .max(120)
    .required(),
  invoiceInterval: yup
    .number()
    .typeError('Preencha este campo')
    .min(0)
    .max(15)
    .required(),
  paymentMaxSplit: yup
    .number()
    .typeError('Preencha este campo')
    .min(0)
    .max(120)
    .required(),
  paymentDaysToGenerate: yup
    .number()
    .typeError('Preencha este campo')
    .min(0)
    .max(120)
    .required(),
  invoicesGenerationOnOverdue: yup.string().required(),
})

export default schemaInvoice
